import { api } from "@/api";
import {
  ClearBettingMarketSuspensionsParams,
  ClearBettingMarketSuspensionsResponse,
} from "@/types/ApiResponses/BettingMarket";

export const clearBettingMarketsSuspensions = async (
  params: ClearBettingMarketSuspensionsParams
): Promise<ClearBettingMarketSuspensionsResponse> => {
  const res = await api.client.delete(`/betting-markets-new/suspensions`, {
    params,
  });
  return res.data;
};
